import { AHIcon, AHText, Box, ColorType, TouchableBox } from "arkh";
import React, { useCallback } from "react";
import { Platform, View } from "react-native";

export function ColumnTitle(props: {
  children: React.ReactNode;
  color?: ColorType;
}) {
  return (
    <Box style={{ height: 20, flexDirection: "row", alignItems: "center" }}>
      <AHText
        color={props.color ?? "text-secondary"}
        numberOfLines={1}
        type="subtitle"
      >
        {props.children}
      </AHText>
    </Box>
  );
}

export function SortableColumnTitle(props: {
  order: "ASC" | "DESC" | null;
  onOrderChange: (order: "ASC" | "DESC") => void;
  onOrderBySelect: () => void;
  title: React.ReactNode;
  disabled?: boolean;
}) {
  const onPress = useCallback(() => {
    if (props.order !== null) {
      props.onOrderChange(props.order === "ASC" ? "DESC" : "ASC");
    } else {
      props.onOrderBySelect();
    }
  }, [props]);

  return (
    <TouchableBox
      onPress={props.disabled ? undefined : onPress}
      disabled={props.disabled}
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <ColumnTitle
        color={props.order !== null ? "text-primary" : "text-secondary"}
      >
        {props.title}
      </ColumnTitle>
      <AHText color="text-primary">
        <Box
          style={{
            opacity: props.order === null ? 0 : 1,
            transform: [{ translateY: props.order === null ? -5 : 0 }],
            ...(Platform.OS === "web"
              ? ({ transition: ".2s transform" } as any)
              : {}),
          }}
          spaceLeft="xxsmall"
        >
          <View
            style={{
              ...(Platform.OS === "web"
                ? ({ transition: ".3s transform" } as any)
                : {}),
              transform: [
                { rotate: props.order === "ASC" ? "180deg" : "0deg" },
              ],
            }}
          >
            <AHIcon
              forceSize={14}
              type="arrow-down"
              color={props.order !== null ? "text-primary" : "text-secondary"}
            />
          </View>
        </Box>
      </AHText>
    </TouchableBox>
  );
}
